module.exports = __webpack_public_path__ + "img/sinBarreras224.1a5b395d.jpg";